import { render, staticRenderFns } from "./ReportFormModal.vue?vue&type=template&id=06674f83&scoped=true&"
import script from "./ReportFormModal.vue?vue&type=script&lang=js&"
export * from "./ReportFormModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportFormModal.vue?vue&type=style&index=0&id=06674f83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06674f83",
  null
  
)

export default component.exports